import React,{useState,useEffect, useRef} from 'react'
import { Form,Modal,App,Input, Radio } from 'antd'
import MyEditor from '../../cpn/MyEditor';
import { useHouduankaifaUpdateQuery, useHouduankaifaUpdateSaveMutation,  } from '../../store/BnsKeJiApi';
import { EditOutlined } from '@ant-design/icons';
import { backendAction } from './backendAction';
const {TextArea} = Input
function BackendEdit(props) {
    const {message} = App.useApp()
    const [form] = Form.useForm();
    const onCreate = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [open,setOpen] = useState()
    const [info,setInfo] = useState({
        etul_content: '',
        etul_name: '',
        etul_update_uid: props.eu_id,
        etul_update_uname: props.eu_name,
        etul_id:props.etul_id,
        etul_level:'1',
    });
    const {data,isSuccess} = useHouduankaifaUpdateQuery({etul_id:props.etul_id},{skip:!open})
    const editForm = useRef();
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                editForm.current.setFieldsValue({
                    etul_content:data.Result.etul_content,
                    etul_name:data.Result.etul_name,                          
                    etul_state:data.Result.etul_state,     
                    etul_level:data.Result.etul_level,     
                    etul_action:data.Result.etul_action,     
                    etul_require:data.Result.etul_require,     
                });
                setInfo(prevState=>({...prevState,
                    etul_content:data.Result.etul_content,
                    etul_name:data.Result.etul_name,           
                    etul_state:data.Result.etul_state,           
                    etul_bg_id:data.Result.etul_bg_id,           
                    etul_bg_name:data.Result.etul_bg_name,           
                    etul_bgn_id:data.Result.etul_bgn_id,           
                    etul_bgn_name:data.Result.etul_bgn_name,           
                    etul_bbb_id:data.Result.etul_bbb_id,           
                    etul_bbb_name:data.Result.etul_bbb_name,           
                    etul_et_id:data.Result.etul_et_id,           
                    etul_et_name:data.Result.etul_et_name,           
                    etul_level:data.Result.etul_level, 
                    etul_action:data.Result.etul_action,     
                    etul_require:data.Result.etul_require,            
                }))
            }
        }
    },[data, isSuccess,])
    const [summitUpdateSave] = useHouduankaifaUpdateSaveMutation()
    return (
        <>
            {localStorage.getItem('eu_id') === props.etul_uid && <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改任务</a>}
            <Modal
                open={open}
                title='修改任务'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                width={1000}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        }); 
                        summitUpdateSave(info).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.success('修改成功！')                                
                                setOpen(false)                         
                            }
                            if (res.data.Status === 'fail') {
                                message.error('修改失败！'+res.data.Message)
                                
                            }
                        })                           
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_module_edit_${props.etul_id || ''}`} // 保证唯一
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >               
                    <Form.Item 
                        name="etul_action" 
                        label='任务类型' 
                        wrapperCol={{span:21}} 
                        required 
                    >                        
                        <Radio.Group   
                            options={backendAction}
                            buttonStyle='solid'
                            optionType="button" 
                            onChange={(e) => {setInfo(prevState=>({...prevState,etul_action:e.target.value,}))}}
                        >
                            
                        </Radio.Group>
                    </Form.Item> 
                    <Form.Item name="etul_name" label='字段名称' wrapperCol={{span:15}}>                        
                        <TextArea  onChange={(e) => {setInfo(prevState=>({...prevState,etul_name:e.target.value,}))}}/>
                    </Form.Item>
                    <Form.Item name="etul_require" label='字段可选' wrapperCol={{span:15}}>                        
                        <TextArea  onChange={(e) => {setInfo(prevState=>({...prevState,etul_require:e.target.value,}))}}/>
                    </Form.Item> 
                    <Form.Item 
                        name="etul_content" 
                        label='任务说明' 
                        wrapperCol={{span:21}}                        
                    >
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,etul_content:e}))}}/>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default BackendEdit